/* CineBuch review empty state — test theme 196518183239 only. */
(() => {
  const ROOT_SELECTOR = '#judgeme_product_reviews';
  const EMPTY_COPY = /keine elemente gefunden|schreiben sie die erste bewertung|be the first to write a review/i;
  const BUTTON_COPY = /bewertung schreiben|erste bewertung|write a review/i;
  const initialRoots = Array.from(document.querySelectorAll(ROOT_SELECTOR));

  if (!initialRoots.length) return;

  const icon = `
    <svg viewBox="0 0 64 64" aria-hidden="true" fill="none">
      <path d="m32 8.5 6.8 13.8 15.2 2.2-11 10.7 2.6 15.1L32 43.2l-13.6 7.1L21 35.2 10 24.5l15.2-2.2L32 8.5Z" fill="currentColor" stroke="currentColor" stroke-width="3" stroke-linejoin="round"/>
      <path d="M49 9v8M45 13h8" stroke="currentColor" stroke-width="3" stroke-linecap="round"/>
    </svg>`;

  const check = `
    <svg viewBox="0 0 20 20" aria-hidden="true" fill="none">
      <path d="m4.5 10 3.2 3.2 7.8-7.4" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>`;

  const stars = Array.from({ length: 5 }, () => `
    <svg viewBox="0 0 64 64" aria-hidden="true" fill="currentColor">
      <path d="m32 5.5 8.2 16.6 18.3 2.7-13.3 12.9 3.2 18.2L32 47.3l-16.4 8.6 3.2-18.2L5.5 24.8l18.3-2.7L32 5.5Z"/>
    </svg>`).join('');

  function findWriteButton(root) {
    return Array.from(root.querySelectorAll('button, a')).find((element) =>
      BUTTON_COPY.test((element.textContent || '').trim())
    );
  }

  function getKnownReviewCount(root) {
    const productId = root.dataset.productId || root.dataset.id;
    const widgetData = window.jdgm?.data?.reviewWidget?.[productId];
    const count = Number(widgetData?.number_of_reviews);
    return Number.isFinite(count) ? count : null;
  }

  function createLoadingCard(root) {
    const sibling = root.previousElementSibling;
    if (sibling?.classList.contains('cinebuch-review-empty-card')) return;

    const card = document.createElement('section');
    card.className = 'cinebuch-review-empty-card cinebuch-review-empty-card--loading';
    card.setAttribute('aria-label', 'Kundenbewertungen werden geladen');
    card.setAttribute('aria-busy', 'true');
    card.innerHTML = `
      <div class="cinebuch-review-empty-card__icon">${icon}</div>
      <div class="cinebuch-review-empty-card__content" aria-hidden="true">
        <div class="cinebuch-review-empty-card__skeleton cinebuch-review-empty-card__skeleton--eyebrow"></div>
        <div class="cinebuch-review-empty-card__skeleton cinebuch-review-empty-card__skeleton--title"></div>
        <div class="cinebuch-review-empty-card__skeleton cinebuch-review-empty-card__skeleton--text"></div>
        <div class="cinebuch-review-empty-card__skeleton cinebuch-review-empty-card__skeleton--text-short"></div>
      </div>
      <div class="cinebuch-review-empty-card__action" aria-hidden="true">
        <div class="cinebuch-review-empty-card__skeleton cinebuch-review-empty-card__skeleton--button"></div>
      </div>`;
    root.parentNode.insertBefore(card, root);
    root.classList.remove('cinebuch-review-native-visible');
    root.classList.add('cinebuch-review-native-hidden');
  }

  function createCard(root, nativeButton) {
    const loadingCard = root.previousElementSibling;
    if (loadingCard?.classList.contains('cinebuch-review-empty-card--loading')) {
      loadingCard.remove();
    }
    const titleId = `cinebuch-review-title-${root.dataset.productId || 'product'}`;
    const card = document.createElement('section');
    card.className = 'cinebuch-review-empty-card';
    card.setAttribute('aria-labelledby', titleId);
    card.innerHTML = `
      <div class="cinebuch-review-empty-card__icon">${icon}</div>
      <div class="cinebuch-review-empty-card__content">
        <p class="cinebuch-review-empty-card__eyebrow">Kundenbewertungen</p>
        <h2 class="cinebuch-review-empty-card__title" id="${titleId}">Ihre Meinung zählt.</h2>
        <p class="cinebuch-review-empty-card__text">Dieses Produkt wurde noch nicht bewertet. Teilen Sie Ihre Erfahrung und helfen Sie anderen bei ihrer Auswahl.</p>
        <div class="cinebuch-review-empty-card__meta">
          <span>${check}In wenigen Minuten erledigt</span>
          <span>${check}Für alle Besucher sichtbar</span>
          <span>${check}Ehrlich &amp; hilfreich</span>
        </div>
      </div>
      <div class="cinebuch-review-empty-card__action">
        <div class="cinebuch-review-empty-card__stars" role="img" aria-label="Fünf Sterne">${stars}</div>
        <button class="cinebuch-review-empty-card__button" type="button">
          Bewertung schreiben
          <svg viewBox="0 0 20 20" aria-hidden="true" fill="none"><path d="M4 10h11m-4-4 4 4-4 4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
        </button>
      </div>`;

    const reviewModalIsVisible = () =>
      Array.from(document.querySelectorAll('.jm-mfp-wrap, .jm-mfp-bg, .jdgm-modal, [role="dialog"]')).some((element) => {
        const style = window.getComputedStyle(element);
        const rect = element.getBoundingClientRect();
        return style.display !== 'none' && style.visibility !== 'hidden' && rect.width > 0 && rect.height > 0;
      });

    const restoreEmptyCard = () => {
      root.dataset.cinebuchReviewOpened = '';
      const text = (root.textContent || '').replace(/\s+/g, ' ').trim();
      if (EMPTY_COPY.test(text)) {
        root.classList.remove('cinebuch-review-native-visible');
        root.classList.add('cinebuch-review-native-hidden');
        card.hidden = false;
      } else {
        root.classList.remove('cinebuch-review-native-hidden');
        root.classList.add('cinebuch-review-native-visible');
        card.remove();
      }
    };

    const watchForModalClose = () => {
      let modalWasVisible = false;
      let checks = 0;
      const interval = window.setInterval(() => {
        checks += 1;
        const modalVisible = reviewModalIsVisible();
        modalWasVisible ||= modalVisible;

        if (modalWasVisible && !modalVisible) {
          window.clearInterval(interval);
          window.setTimeout(restoreEmptyCard, 120);
        } else if (!modalWasVisible && checks >= 20) {
          window.clearInterval(interval);
          restoreEmptyCard();
        } else if (checks >= 1200) {
          window.clearInterval(interval);
          restoreEmptyCard();
        }
      }, 100);
    };

    card.querySelector('button').addEventListener('click', () => {
      root.dataset.cinebuchReviewOpened = 'true';
      root.classList.remove('cinebuch-review-native-visible');
      root.classList.add('cinebuch-review-native-hidden');
      card.hidden = false;
      requestAnimationFrame(() => {
        nativeButton.click();
        watchForModalClose();
      });
    });

    root.parentNode.insertBefore(card, root);
    root.classList.remove('cinebuch-review-native-visible');
    root.classList.add('cinebuch-review-native-hidden');
    root.dataset.cinebuchReviewEnhanced = 'true';
  }

  function enhance() {
    document.querySelectorAll(ROOT_SELECTOR).forEach((root) => {
      if (root.dataset.cinebuchReviewOpened === 'true') return;

      const existingCard = root.previousElementSibling;
      if (
        existingCard?.classList.contains('cinebuch-review-empty-card') &&
        !existingCard.classList.contains('cinebuch-review-empty-card--loading')
      ) return;

      if (root.dataset.cinebuchReviewEnhanced === 'true') {
        root.dataset.cinebuchReviewEnhanced = '';
      }

      const text = (root.textContent || '').replace(/\s+/g, ' ').trim();
      if (!text) return;

      root.classList.remove('cinebuch-review-reviewed-loading');

      if (!EMPTY_COPY.test(text)) {
        const loadingCard = root.previousElementSibling;
        if (loadingCard?.classList.contains('cinebuch-review-empty-card--loading')) {
          loadingCard.remove();
        }
        root.classList.remove('cinebuch-review-native-hidden');
        root.classList.add('cinebuch-review-native-visible');
        return;
      }

      const nativeButton = findWriteButton(root);
      if (!nativeButton) return;

      createCard(root, nativeButton);
    });
  }

  function prime() {
    document.querySelectorAll(`${ROOT_SELECTOR}[data-empty-state="show_empty_widget"]`).forEach((root) => {
      const reviewCount = getKnownReviewCount(root);
      if (reviewCount !== null && reviewCount > 0) {
        root.classList.remove('cinebuch-review-native-hidden');
        root.classList.add('cinebuch-review-native-visible', 'cinebuch-review-reviewed-loading');
        return;
      }
      createLoadingCard(root);
    });
  }

  let timer;
  const schedule = () => {
    if (timer) return;
    timer = window.setTimeout(() => {
      timer = undefined;
      enhance();
    }, 60);
  };

  prime();
  schedule();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  }

  const observer = new MutationObserver(schedule);
  initialRoots.forEach((root) => {
    observer.observe(root.parentElement || root, { childList: true, subtree: true });
  });
  window.setTimeout(() => observer.disconnect(), 20000);
})();
